const promotionBar = {
    settings: {

    }
};

export default promotionBar;